export default "__VITE_ASSET__7235797f__"